/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/jsx-no-useless-fragment */
import React, { useContext } from 'react';
import PropTypes from 'prop-types';

import clsx from 'clsx';
import { TabsContext } from '../../../../context/tabs/tabsContext';
import { PerfiladorPrecioInmueble } from '../PerfiladorPrecioInmueble';
import { PerfiladorIngresosMensuales } from '../PerfiladorIngresosMensuales';
import { TabPanel } from '../../../../components/TabPanel';
import useStyles from './useStyles';
import { PerfiladorUniqueScreen } from '../PerfiladorUniqueScreen';
import { objectUtils } from '../../../../utils';

export const PerfiladorBodyTabs = ({
  buttonTitle, onSubmit, showFooter,
  footerText,
}) => {
  const { state: { tabs, active }, tabsExtraClasses } = useContext(TabsContext);

  const classes = useStyles();

  const renderTabs = () => {
    if (!objectUtils.isArrayWithItems(tabs)) return null;
    if (tabs.length === 1) {
      return (
        <TabPanel
          value={active}
          index={tabs[0].value}
        >
          <PerfiladorUniqueScreen
            onSubmit={onSubmit}
            showFooter={showFooter}
            footerText={footerText}
            buttonText={buttonTitle}
          />
        </TabPanel>
      );
    }
    return (
      <>
        <TabPanel
          value={active}
          index={tabs[0].value}
        >
          <PerfiladorPrecioInmueble
            onSubmit={onSubmit}
            buttonTitle={buttonTitle}
            showFooter={showFooter}
          />
        </TabPanel>
        <TabPanel
          value={active}
          index={tabs[1].value}
        >
          <PerfiladorIngresosMensuales
            onSubmit={onSubmit}
            buttonTitle={buttonTitle}
            showFooter={showFooter}
          />
        </TabPanel>
      </>
    );
  };

  return (
    <div className={clsx({
      [classes.container]: true,
      [tabsExtraClasses?.container]: tabsExtraClasses?.container,
    })}
    >
      <div className={classes.tabsContainer}>
        {renderTabs()}
      </div>
    </div>
  );
};

PerfiladorBodyTabs.propTypes = {
  buttonTitle: PropTypes.string,
  onSubmit: PropTypes.func,
  showFooter: PropTypes.bool,
  footerText: PropTypes.string,
};

PerfiladorBodyTabs.defaultProps = {
  buttonTitle: '',
  onSubmit: () => {},
  showFooter: false,
  footerText: '',
};
